import { Divider, Fab, FormControlLabel, IconButton, MenuItem, Tooltip } from "@mui/material";
import { Add as AddIcon, Edit as EditIcon, Delete as DeleteIcon, MoreHoriz as MoreHorizIcon, QrCode as QrCodeIcon } from "@mui/icons-material";
import LoaderSwitch from "components/Loaders/LoaderSwitch";
import { Android12Switch } from "components/Styled";
import Add from "./Add";
import Edit from "./Edit";
import Remove from "./Remove";
import Style from "./Style";

export function ActionsDialogPage({ open, close, instance, reportAction }) {
  return (<>
    <Add 
      open={open === 1} 
      close={close} 
      reportAction={reportAction} />
    <Edit 
      open={open === 2} 
      close={close} 
      instance={instance} 
      reportAction={reportAction} />
    <Remove 
      open={open === 3} 
      close={close} 
      instance={instance} 
      reportAction={reportAction} />
    {open === 4 ?
      <Style 
        open={open === 4} 
        close={close} 
        instance={instance} 
        reportAction={reportAction} />
      : null}
  </>)
}

export function ActionFabButtonAdd({ t, action}) {
  return (
    <span className="fab_add">
      <Tooltip title={t("qrcode_page_add_button_text")}>
        <Fab color="primary" onClick={action}> <AddIcon /></Fab>
      </Tooltip>
    </span>
  )
}

export function  ActionsMenuPage({ t, action }) {
  // 2: edit, 3: delete, 4: style
  return (<> 
    <MenuItem onClick={() => action(2)} disableRipple> 
      <EditIcon /> {t("qrcode_page_edit_button_text")} 
    </MenuItem>
    <MenuItem onClick={() => action(4)} disableRipple> 
      <QrCodeIcon /> {t("qrcode_page_style_button_text")} 
    </MenuItem>
    <Divider />
    <MenuItem onClick={() => action(3)} disableRipple> 
      <DeleteIcon /> {t("qrcode_page_delete_button_text")} 
    </MenuItem>
  </>)
}

export function ActionsMUIRowRender({ value, data, open, actionClickMenu, loadingUpdateActive, itemId, getActive, actionUpdateActive }) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <IconButton 
        sx={{ marginRight: 1.5 }}
        id="demo-customized-button" 
        aria-haspopup="true" 
        variant="contained"
        aria-controls={open ? 'demo-customized-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={(event) => actionClickMenu(event, value)}>
        <MoreHorizIcon />
      </IconButton>
      {(loadingUpdateActive && itemId === value) ?
        <LoaderSwitch on={getActive(value, data)} /> :
        <FormControlLabel style={{ marginRight: 4 }}
          control={
            <Android12Switch checked={getActive(value, data)}
              disabled={(loadingUpdateActive && itemId === value)}
              onClick={() => actionUpdateActive(value)} />
          } />
      }
    </div>
  )
}